// extracted by mini-css-extract-plugin
module.exports = {"pageLoader":"PageLoader_pageLoader__CRgPR","appLoading":"PageLoader_appLoading__30GIN"};